import {toast} from "react-toastify";

export default {
    token: localStorage.getItem("token") ? localStorage.getItem("token").length > 5 ? localStorage.getItem("token") : "" : "",
    api: "https://api.ghestitak.ir",
    // api: "http://192.168.1.2:8788",
    majidAPI: "https://api.majidapi.ir",
    setTitle: (title = "قسطی تک") => {
        try {
            document.title = title;
        } catch (err) {
            console.error("setTitle: ", err);
        }
        return true;
    },
    handleError: (errorBody = null) => {
        let err = "خطا!";
        if (errorBody) {
            if (errorBody.message) {
                err = errorBody.message
            } else if (errorBody.error) {
                err = errorBody.error;
            }
        }
        toast.error(err);
        return err;
    },
    scrollTop: () => {
        try {
            document.getElementById("header").scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "start"
            });
        } catch (err) {
        }
    },
    priceFormatter: (price = "") => {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    sleep: (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    },
    random: (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    },
}